document.addEventListener('DOMContentLoaded', function() {
  var link = document.querySelector('a[href="#shopify-section-template--24784177037645__timeline_LRxgR9"]');
  if (!link) return;

  link.addEventListener('click', function(e) {
    e.preventDefault();
    var target = document.getElementById('shopify-section-template--24784177037645__timeline_LRxgR9');
    if (!target) return;

    // header fixe si besoin
    var offset = 80; 
    var startY = window.pageYOffset;
    var targetY = target.getBoundingClientRect().top + startY - offset;
    var distance = targetY - startY;
    var duration = 2000; // durée en ms

    var startTime = null;
    function easeInOutQuad(t) {
      return t < 0.5
        ? 2 * t * t
        : -1 + (4 - 2 * t) * t;
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var time = timestamp - startTime;
      var progress = Math.min(time / duration, 1);
      var eased = easeInOutQuad(progress);
      window.scrollTo(0, startY + distance * eased);
      if (time < duration) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  });
});
